export default __webpack_public_path__ + "static/media/katie_allen.c6197cab.jpg";